export default __webpack_public_path__ + "static/ufo-afcdb0f7b715923a471b770b38bf867d.png";